import { render } from "./budgets-expenses.vue?vue&type=template&id=5513d567"
import script from "./budgets-expenses.vue?vue&type=script&lang=js"
export * from "./budgets-expenses.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__